<div
  v-if="shouldRenderConfig"
  v-bind:class="getClassName"
  v-show="getSummaryPageOptionActive"
>
  <div v-bind:class="getClassName + 'Right'">
    <div class="header-text">
      {{$t(' So geht es jetzt weiter: ')}}
     </div>
    <appCostCenter></appCostCenter>
    <appQuantityTable>
      <appQuantityContainer></appQuantityContainer>
      <appInputQuantity></appInputQuantity>
    </appQuantityTable>
    <div v-bind:class="getClassName + 'RightContainer'">
      <div :class="['matrix_stepsContainer ', getHideLinks ? 'upload-selected': 'personalization-selected']">
        <div class="steps">
          <div class="step">
            <span class="step-no">1.</span>
            <div class="circle-container">
              <span class="circle download"></span>
              <div v-if="!getHideLinks" class="text">
                {{$t('Download der  Druckvorlagen')}}
              </div>
              <div v-else class="text">
                {{$t('Klicken Sie auf den Button �Zum 3D-Editor�')}}
              </div>
            </div>
          
          </div>
          <div class="step">
            <span class="step-no">2.</span>
            <div class="circle-container">
              <span class="circle edit"></span>
              <div  v-if="!getHideLinks" class="text">
                {{$t('Druckdatei im Lieblings-grafikprogramm ge- stalten oder Agentur beauftragen')}}
              </div>
              <div v-else class="text">
                {{$t('W�hlen Sie aus unseren Standardbildern Ihren Favorit')}}
              </div>
            </div>           
          </div>
          <div class="step">
            <span class="step-no">3.</span>
            <div class="circle-container">
              <span class="circle upload"></span>
              <div v-if="!getHideLinks" class="text" v-html="$t('Fertige Datei im <br/> 3D-Editor hochladen (PDF)')"> </div>
              <div v-else class="text">
                {{$t('Plazieren Sie Ihr Logo an den gew�nschten Postitionen')}}
              </div>
            </div>
    
          </div>
          <div class="step">
            <span class="step-no">4.</span>
            <div class="circle-container">
              <span class="circle live-preview"></span>
              <div  v-if="!getHideLinks" class="text">
                {{$t('In einer Live-Vorschau sehen Sie das fertige Produkt')}}
              </div>
              <div v-else class="text">
                {{$t('In einer Live-Vorschau sehen Sie das fertige Produkt')}}
              </div>
            </div>
          
          </div>
        </div>
      </div>
      <div :class="['bottom-container ', getHideLinks ? 'upload-selected': 'personalization-selected']">
        <div v-if="!getHideLinks" class="left-container">
          <div class="links-container">
            <h3>{{$t('Download Druckvorlagen')}}</h3>
            <appFactsheet></appFactsheet>
           <a :href="getInstructionsUrl" target="_blank"><span class="matrix_arrowIcon"></span>{{printingInfo}}</a>
          </div>
        </div>
        <div class="right-container">
          <appPersonalizationButton
        class="matrix_personzalizeButtonMain"
        v-show="(getSummaryPageOptionActive || getMatrixComplete) && getPersonalizationFullPage"
      ></appPersonalizationButton>
        </div>
      </div>
      <!-- <div v-bind:class="getClassName + 'RightUpload'">
        <appUploadTable alwaysShow="true"></appUploadTable>
        <div v-show="(getSummaryPageOptionActive || getMatrixComplete) && getPersonalizationFullPage" class="matrix_summaryDesignLogoContainer">
            <div v-if="getHideUploadContainer" class="matrix_summaryDesignLogoHeader matrix_summaryHeader">{{designLogoHeader}}</div>
            <div class="matrix_summaryDesignLogocontent">{{designLogoContent}}</div>
        </div>
       
      </div> -->
      <!-- <div v-bind:class="getClassName + 'RightFact'">
        <appFactsheet></appFactsheet>
        <div class="matrix_summaryDesignLogoContainer">
            <div class="matrix_summaryDesignLogoHeader matrix_summaryHeader">{{helpHeader}}</div>
            <div class="matrix_summaryDesignLogocontent" v-html="helpContent"></div>
        </div>
        <div class="matrix_summaryPrintingInstructions" v-if="!getHideUploadContainer">
            <a :href="getInstructionsUrl" target="_blank"><span class="matrix_arrowIcon"></span>{{printingInfo}}</a>
        </div>        
      </div> -->
    </div>
  </div>
  <div v-bind:class="getClassName + 'Left'">
    <appOtherOptionsTable>
      <appOtherOptionsContainer></appOtherOptionsContainer>
    </appOtherOptionsTable>
    <div class="matrix_summaryInformation">
      <appSummaryTable></appSummaryTable>
    </div>
    <div class="matrix_summaryDesignLogoContainer">
      <div class="matrix_summaryDesignLogoHeader matrix_summaryHeader">{{helpHeader}}</div>
      <div class="matrix_summaryDesignLogocontent" v-html="helpContent"></div>
  </div>
    <appAddToCartButton
      class="matrix_addToCartButtonMain"
      v-show="getAddToCartFullPage"
    ></appAddToCartButton>
  </div>
</div>
